const translations = {
  clustering: 'Clustering',
  showUsers: 'Show users',
  showPlaces: 'Show places',
  route: 'Route',
  selectUserAndHours: 'Select the user and the last hours traveled.',
  user: 'User',
  lastHours: 'Last hours',
  search: 'Search',
  removeRoute: 'Remove route',
  selectUserError: 'Select a user.',
  setHoursError: 'Set the number of hours.'
}

export default translations
